const getToken = () => window.userToken || localStorage.getItem("token");
const getAuthProvider = () => localStorage.getItem("portal");

const resolveBaseUrl = () =>
  `${process.env.REACT_APP_ENDPOINT}${process.env.REACT_APP_ENDPOINT_VERSION}`;

export async function get(url: string, isUpdated?: boolean) {
  return fetch(
    `${resolveBaseUrl()}${url}${isUpdated ? "?t=" + Date.now() : ""}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${getToken()}`,
        "Content-Type": "application/json",
        oid: window.localStorage.getItem("oid") || "",
        "portal": window.localStorage.getItem("portal") || ""
      },
    }
  );
}

export async function getWithHeaders(url: string, isUpdated?: boolean, headers?: any, resolveBasePath?: boolean) {
  return fetch(
    `${ resolveBasePath ? resolveBaseUrl() : 
    ""}${url}${isUpdated ? "?t=" + Date.now() : ""}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${getToken()}`,
        "Content-Type": "application/json",
        oid: window.localStorage.getItem("oid") || "",
        portal: window.localStorage.getItem("portal") || "",
        ...headers
      },
    }
  );
}

export async function post(url: string, body: any) {
  return fetch(`${resolveBaseUrl()}${url}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${getToken()}`,
      "Content-Type": "application/json",
      oid: window.localStorage.getItem("oid") || "",
      portal: window.localStorage.getItem("portal") || ""
    },
    body: JSON.stringify(body),
  });
}

export async function patch(url: string) {
  return fetch(`${resolveBaseUrl()}${url}`, {
    method: "PATCH",
    headers: {
      Authorization: `Bearer ${getToken()}`,
      "Content-Type": "application/json",
      oid: window.localStorage.getItem("oid") || "",
      portal: window.localStorage.getItem("portal") || ""
    },
  });
}